<template>
  <div>
    <v-btn
      color="#f00"
      text
      small
      @click.stop="deleteAllDiagrams()"
    >
      何も表示されなくなってしまった方
    </v-btn>

    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card>
        <v-card-text class="text-h6 pt-4">自動保存されているデータが壊れているため、<span class="font-weight-bold red--text">すべての</span>ポジショニングマップデータを削除する必要があります。すべてのポジショニングマップを削除した後、事前にダウンロード（<span class="body-2">画面右上</span> <v-icon color="primary">mdi-download</v-icon>）した各ポジショニングマップのバックアップファイルをインポート（<span class="body-2">画面右上</span> <v-icon color="primary">mdi-database-import</v-icon>）することで復帰できます。</v-card-text>

        <div class="text-center my-3">
          <v-btn
            color="red"
            dark
            depressed
            @click.stop="deleteDialog = true"
          >
            すべてのデータを削除する
          </v-btn>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DeleteAllDialogs
      :delete-dialog="deleteDialog"
      @close-diagram="deleteDialog = false"
    ></DeleteAllDialogs>
  </div>
</template>

<script>
import DeleteAllDialogs from '@/components/DeleteAllDialogs'

export default {
  components: {
    DeleteAllDialogs
  },
  data () {
    return {
      dialog: false,
      deleteDialog: false
    }
  },
  methods: {
    deleteAllDiagrams () {
      this.dialog = true
    }
  }
}
</script>
